import React, { useState, useRef, useEffect } from "react";
import "./dropdown.css";

export const Dropdown = ({ label, options }) => {
  const [isActive, setIsActive] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsActive(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleDropdownToggle = () => {
    setIsActive(!isActive);
  };

  const handleItemClick = (item) => {
    setSelectedValue(item);
    setIsActive(false);
  };

  return (
    <label>
      {label}
      <div
        className={`select-input ${isActive ? "-active" : ""} ${
          selectedValue ? "-selected" : ""
        }`}
        ref={dropdownRef}
      >
        <input type="text" />
        <div className="--dropdown__value" onClick={handleDropdownToggle}>
          <span className="--dropdown__value-text body1">
            {selectedValue ? (
              <div>
                {selectedValue?.image && (
                  <img src={selectedValue?.image} alt={selectedValue?.name} />
                )}
                {selectedValue?.name}
              </div>
            ) : (
              <div>
                <img src={options[0].image} alt={options[0].image} />
                {options[0].name}
              </div>
            )}
          </span>
        </div>
        <ul>
          {options
            .filter(
              (el) =>
                el?.name !==
                (selectedValue ? selectedValue?.name : options[0].name)
            )
            .map((el) => (
              <li
                className="body1"
                onClick={() => handleItemClick(el)}
                key={el.name}
              >
                {el.image && <img src={el.image} alt={el.name} />}
                {el.name}
              </li>
            ))}
        </ul>
      </div>
    </label>
  );
};
